import { motion } from "framer-motion";
import { ShareButtons } from "@/components/ShareButtons";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-linen bg-white/40">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="font-serif text-[16vw] font-semibold leading-none tracking-tighter text-forest/15 md:text-[11vw]"
          data-testid="footer-wordmark"
        >
          BookCare
        </motion.h2>
        <div className="mt-16 grid grid-cols-1 gap-12 border-t border-linen pt-12 md:grid-cols-3">
          <div>
            <img
              src="/logo-bookcare.png"
              alt="BookCare LLC — Nurturing Prudent Decisions"
              className="mb-6 h-24 w-24 rounded-sm object-cover"
              data-testid="footer-logo-img"
            />
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-terra">Contact</p>
            <div className="flex flex-col gap-2 font-mono text-sm text-pine/75">
              <a href="mailto:Info@bookcarellc.com" data-testid="footer-email-link" className="transition-colors duration-300 hover:text-forest">Info@bookcarellc.com</a>
              <a href="tel:+14253459757" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-forest">425-345-9757</a>
              <span>Farmersville, TX · In person anywhere in the USA &amp; remotely</span>
            </div>
          </div>
          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-terra">Services</p>
            <div className="flex flex-col gap-2 font-mono text-sm text-pine/75">
              <span>Bookkeeping &amp; Accounting</span>
              <span>Tax Preparation &amp; Planning</span>
              <span>Fractional CFO &amp; Controller</span>
              <span>Career Coaching</span>
              <span>Financial Solution Strategies</span>
            </div>
          </div>
          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-terra">Connect</p>
            <div className="flex flex-col gap-2 font-mono text-sm text-pine/75">
              <a href="https://linkedin.com/in/zecharias-mesgane" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="transition-colors duration-300 hover:text-forest">
                LinkedIn — Zecharias Mesgane
              </a>
              <a href="#contact" data-testid="footer-consultation-link" className="transition-colors duration-300 hover:text-forest">
                Schedule a consultation
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-linen pt-10">
          <ShareButtons label="Know someone who needs this? Share BookCare" />
        </div>
        <div className="mt-10 flex flex-col justify-between gap-4 border-t border-linen pt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-pine/50 md:flex-row">
          <span data-testid="footer-copyright">© 2026 BookCare LLC · All rights reserved</span>
          <span>Our strength. Your numbers.</span>
        </div>
      </div>
    </footer>
  );
}
